import { useEffect, useState } from "react";
import axios from "axios";

const DownloadSection = () => {
  const [downloadItems, setDownloadItems] = useState([]);

  useEffect(() => {
    axios.get("https://admin.asiaticstock.in/api/downloads", {
      headers: {
        "api-key": "ASSL#2025_@Stock"
      }
    })
      .then((res) => {
        if (res.data.success && Array.isArray(res.data.data)) {
          setDownloadItems(res.data.data);
        }
      })
      .catch(() => {
        setDownloadItems([]);
      });
  }, []);

  return (
    <section className="about about--style1 bg-color xts-section">
      <div className="container">                         
        <div className="about__wrapper">
          <div className="row align-items-center">
            <div className="col-lg-12">
              <div className="about__content" data-aos="fade-left" data-aos-duration="800">
                <div className="about__content-inner">
                  <h2 className="meet-oppurtanity">Forms & <span className="style2">Policy</span></h2>
                  <h6>Resource id #3</h6>
                  <div className="row justify-content-center trad-platform">
                    <div className="col-md-12">
                      <div className="table-responsive contact-us download">
                        <table className="table table-bordered">
                          <thead style={{ background: "#ddd" }}>
                            <tr>
                              <th>ID</th>
                              <th>Name</th>
                              <th>Description</th>
                            </tr>
                          </thead>
                          <tbody>
                            {downloadItems.map((item) => (
                              <tr key={item.id}>
                                <td>{item.sort_order || item.id}</td>
                                <td>{item.name}</td>
                                <td>
                                  <a
                                    href={item.pdf_url}
                                    className="trk-btn trk-btn--border trk-btn--primary"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    Download
                                    <i className="fa fa-download ms-2"></i>
                                  </a>
                                </td>
                              </tr>
                            ))}

                            {downloadItems.length === 0 && (
                              <tr>
                                <td colSpan="3" className="text-center">No Documents Found</td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DownloadSection;
